module.exports = __webpack_public_path__ + "static/media/mini.20808181.png";